import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

//
import { useAuthContext } from '../hooks';
import { useMockedUser } from 'src/hooks/use-mocked-user';


// ----------------------------------------------------------------------

const loginPaths = {
  jwt: paths.auth.jwt.login,
  auth0: paths.auth.auth0.login,
  amplify: paths.auth.amplify.login,
  firebase: paths.auth.firebase.login,
};

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const router = useRouter();
  const { user } = useMockedUser();

  const { method } = useAuthContext();
  const [checked, setChecked] = useState(false);
  const check = useCallback(() => {
    if ( !user || (user?.userType !== "user" && user?.token)) {
      const href = '/auth/login';
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [user, method, router]);


  useEffect(() => {
    check();
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export function AuthGuardSuperAdmin({ children }) {
  const router = useRouter();
  const { user } = useMockedUser();
  const { method } = useAuthContext();
  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if ( !user || (user?.userType !== "super-admin" && user?.token)) {

      // const loginPath = loginPaths[method];
      // const href = `${loginPath}`;
      const href = `/auth/super-admin/login`;
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [user, method, router]);


  useEffect(() => {
    check();
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}

AuthGuardSuperAdmin.propTypes = {
  children: PropTypes.node,
};

export function AuthGuardOrganizer({ children }) {
  const router = useRouter();
  const { user } = useMockedUser();
  const [checked, setChecked] = useState(false);
  const check = useCallback(() => {
    if ( !user || (user?.userType !== "organizer" && user?.token)) {

      // const href = `${paths.auth.amplify.login}`;
      const href = `/auth/login`;
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [user, router]);
  useEffect(() => {
    check();
  }, []);
  if (!checked) {
    return null;
  }
  return <>{children}</>;
}

AuthGuardOrganizer.propTypes = {
  children: PropTypes.node,
};
